export interface PrintSizePrice {
  size: string;
  price: number;
}

const LEGACY_PRINT_SIZES = ["20 × 15 cm", "40 × 30 cm"];

export function getPrintSizePrices(artwork: {
  print_sizes?: string | null;
  print_price_small?: number | null;
  print_price_large?: number | null;
  price: number;
}): PrintSizePrice[] {
  if (artwork.print_sizes) {
    try {
      const parsed = JSON.parse(artwork.print_sizes) as unknown;
      if (Array.isArray(parsed)) {
        const sizes = parsed.flatMap((item) => {
          if (!item || typeof item !== "object") return [];
          const { size, price } = item as Record<string, unknown>;
          const normalizedSize = typeof size === "string" ? size.trim() : "";
          const normalizedPrice = Number(price);
          return normalizedSize && Number.isFinite(normalizedPrice) && normalizedPrice > 0
            ? [{ size: normalizedSize, price: normalizedPrice }]
            : [];
        });
        if (sizes.length > 0) return sizes;
      }
    } catch {
      // Older products do not have the JSON variants column yet.
    }
  }

  return LEGACY_PRINT_SIZES.map((size, index) => ({
    size,
    price: index === 0
      ? artwork.print_price_small ?? artwork.price
      : artwork.print_price_large ?? artwork.price,
  }));
}
